import { Component, inject, Inject, Input, OnInit } from '@angular/core';
import { ExternalAutomationParameter } from '@xprojectorcore/xprojector_backend/proto/xprojector.sysadmin.pb';
import { XProjectorSysAdminClient } from '@xprojectorcore/xprojector_backend/xprojector-sysadmin-client';

@Component({
  selector: 'core-external-automation-parameters',
  templateUrl: './external-automation-parameters.component.html',
  styleUrls: ['./external-automation-parameters.component.scss']
})
export class ExternalAutomationParametersComponent implements OnInit {

  private sysAdminClient: XProjectorSysAdminClient = inject(XProjectorSysAdminClient);

  @Input() customerId : string;

  @Input() externalId1 : string;
  @Input() externalId2 : string;
  @Input() externalId3 : string;
  @Input() externalId4 : string;
  @Input() externalId5 : string;

  @Input() externalKey1 : string;
  @Input() externalKey2 : string;
  @Input() externalKey3 : string;
  @Input() externalKey4 : string;
  @Input() externalKey5 : string;

  @Input() nodeId : string;
  @Input() nodeTypeId : string;

  @Input() filter : {name : string, value : string}[] =[];

  externalAutomationParameters : ExternalAutomationParameter[] = [];

  loading: boolean = false;

  constructor() { }

  ngOnInit() {
    this.updateExternalAutomationParameter()
  }

  async updateExternalAutomationParameter() {
    var response = await this.sysAdminClient.getExternalAutomationParameters(this.customerId);
    // var response = await this.sysAdminClient.getExternalAutomationParameters(this.customerId, this.externalId1, this.externalId2, this.externalId3, this.externalId4, this.externalId5
    //     , this.externalKey1, this.externalKey2, this.externalKey3, this.externalKey4, this.externalKey5);

    this.externalAutomationParameters = [];
    response.externalAutomationParameters.forEach(extParam => {
      let ok = true;
      this.filter.forEach(x => {
        if (extParam[x.name] && !extParam[x.name].startsWith(x.value)) {
          ok = false;
        }
      });
      if (ok) {
        if ((!this.nodeId || this.nodeId.length == 0 || extParam.nodeId == this.nodeId)
          && (!this.nodeTypeId || this.nodeTypeId == extParam.nodeTypeId)) {
          this.externalAutomationParameters.push(extParam);
        }
      }
    });
  }

}
